import {SCORE_COLORS} from '../constants/provider-results.constants';
import {RECOMMENDATION_PERCENTAGE_THRESHOLDS} from '../constants/recommendation-thresholds.constants';

export function getChartColor(percent: number): string {
  if (percent >= RECOMMENDATION_PERCENTAGE_THRESHOLDS.highlyRecommended)
    return SCORE_COLORS.darkGreen;
  if (percent >= RECOMMENDATION_PERCENTAGE_THRESHOLDS.recommended) return SCORE_COLORS.lightGreen;
  if (percent >= RECOMMENDATION_PERCENTAGE_THRESHOLDS.conditionallyRecommended)
    return SCORE_COLORS.yellow;
  if (percent >= RECOMMENDATION_PERCENTAGE_THRESHOLDS.limitedFit) return SCORE_COLORS.orange;
  return SCORE_COLORS.red;
}

export function createScoreChartData(percent: number | undefined): object | null {
  if (percent === undefined) return null;
  return {
    datasets: [
      {
        data: [percent, 100 - percent],
        backgroundColor: [getChartColor(percent), 'oklch(37.3% 0.034 259.733)'],
        borderWidth: 0,
      },
    ],
  };
}
